import { Link } from 'react-router'
import type { JSX } from 'react'
import { useAuth } from '@/auth/context'
import { DEFAULT_HOME } from '@/auth/routes'
import { useBrand } from '@/brand/context'

/**
 * Nothing at this address.
 *
 * Worth its own screen rather than a redirect, because on this host a 404 is
 * almost always a *client-side* one: the SPA-rewrite CloudFront function serves
 * `index.html` for every extensionless path, so a mistyped or stale URL reaches
 * React rather than the edge. Silently redirecting would hide a broken link in
 * an email or a bookmark that no longer resolves.
 */
export function NotFound(): JSX.Element {
  const brand = useBrand()
  const { status } = useAuth()
  return (
    <div className="app-full-state">
      <p className="ar-display">404</p>
      <h1 className="ar-h2">There is nothing at this address</h1>
      <p className="ar-muted" style={{ maxWidth: '42ch' }}>
        The link may be out of date, or part of the address may have been cut off on its way here.
      </p>
      <Link className="ar-btn ar-btn--primary" to={status === 'authenticated' ? DEFAULT_HOME : '/'}>
        {status === 'authenticated' ? `Back to ${brand.productName}` : 'Go to sign in'}
      </Link>
    </div>
  )
}
